import React, { useState } from 'react'

export default function WhyChooseUs() {
  const [isExpanded, setIsExpanded] = useState(false)

  const points = [
    {
      icon: 'fa-laptop-code',
      title: 'Specialiseret i IT & Tech',
      desc: 'Dybdegående forståelse for moderne teknologistacks, softwareudvikling og IT-arkitektur.',
    },
    {
      icon: 'fa-user-check',
      title: 'Personlig rekruttering',
      desc: 'Et tæt og direkte samarbejde med Birgitte Vilsgaard – ingen junior-konsulenter eller mellemlag.',
    },
    {
      icon: 'fa-network-wired',
      title: 'Stærkt netværk',
      desc: 'Mange års opbygget relation og direkte kontakt til både passive og aktive tech-profiler i Danmark.',
    },
    {
      icon: 'fa-briefcase',
      title: 'Erfaring fra branchen',
      desc: 'Lang erfaring fra både bureau- og virksomhedssiden giver et 360-graders perspektiv.',
    },
    {
      icon: 'fa-bullseye',
      title: 'Fokus på det rette match',
      desc: 'Vi vurderer både faglige kompetencer, personlighed og kulturelt fit til jeres virksomhed.',
    },
  ]

  return (
    <section className="py-20 bg-slate-50 border-y border-slate-200/70">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-black tracking-tight">
            Hvorfor vælge Insightly Care?
          </h2>
          <p className="text-black mt-3 text-base leading-relaxed">
            Når du arbejder med Insightly Care, samarbejder du direkte med Birgitte Vilsgaard. Vores tilgang kombinerer dyb tech-forståelse med et stærkt personligt engagement.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {(isExpanded ? points : points.slice(0, 3)).map((p, idx) => (
            <div
              key={idx}
              className="bg-white p-8 border border-slate-200/80 flex flex-col justify-between"
            >
              <div>
                <div className="text-black text-3xl mb-4 flex items-center">
                  <i className={`fa-solid ${p.icon}`} aria-hidden="true" />
                </div>
                <h3 className="text-xl font-bold text-black mb-2">{p.title}</h3>
                <p className="text-black text-sm leading-relaxed">{p.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {points.length > 3 && (
          <div className="mt-10 text-center">
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="inline-flex items-center gap-2 px-6 py-3 bg-white border border-slate-300 text-black font-semibold text-sm hover:bg-slate-100 transition-colors cursor-pointer"
            >
              <span>{isExpanded ? 'Vis færre' : 'Vis flere'}</span>
              <i
                className={`fa-solid fa-chevron-${isExpanded ? 'up' : 'down'} text-xs text-black transition-transform`}
                aria-hidden="true"
              />
            </button>
          </div>
        )}
      </div>
    </section>
  )
}
